import {
  takeLatest,
  put,
  race,
  take,
  call,
  select,
  cancel,
} from 'redux-saga/effects';
import get from 'lodash/get';
import head from 'lodash/head';
import includes from 'lodash/includes';
import { browserHistory } from 'react-router';
import * as success from '../../ui/success';
import * as error from '../../ui/error';
import * as createVisit from '../requests/create-virtual-visit-req';
import * as inspectVirtualVizit from '../requests/inspection-virtual-visit-form';

import { MESSAGES } from '../../../constants/routes';
import { overlapModalActions } from '../overlap-modal';
import { selectOverlapModalEntity } from '../selectors';
import { ERROR_CODES } from '../../../constants/errors';

const {
  PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME,
  PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE,
  APPOINTMENT_IS_EXISTING_AT_THIS_TIME,
  APPOINTMENT_OVERLAPPING,
} = ERROR_CODES;

export function* addVisitWorker({ payload }) {
  yield put(inspectVirtualVizit.actions.send(payload));

  const { succeedInspection, rejectedInspection } = yield race({
    succeedInspection: take(inspectVirtualVizit.consts.SUCCEED),
    rejectedInspection: take(inspectVirtualVizit.consts.REJECTED),
  });

  if (rejectedInspection) {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'errors.common' },
    });
    yield cancel();
  }

  const responseInspection = head(succeedInspection.payload);
  const isCompleted = get(responseInspection, 'completed');

  if (!isCompleted) {
    const fieldList = get(responseInspection, 'fieldList', []);

    const errorCodes = [
      APPOINTMENT_OVERLAPPING,
      APPOINTMENT_IS_EXISTING_AT_THIS_TIME,
    ];

    const isOverlap = fieldList.some(({ code }) =>
      errorCodes.some(errorItem => includes(code, errorItem)),
    );

    if (isOverlap) {
      yield put(overlapModalActions.open(payload));
    } else {
      const msg = get(fieldList, '[0].code[0]');
      const textError = [
        PROVIDER_IS_NOT_AVAILABLE_FOR_THIS_TIME,
        PROVIDER_IS_NOT_AVAILABLE_FOR_SELECTED_SERVICE,
      ].includes(msg)
        ? 'appointment.form.error.notAvailableProvider.combined'
        : 'errors.common';
      yield put({
        type: error.consts.UPDATE,
        payload: { id: textError },
      });
    }
    yield cancel();
  }

  yield call(() => handleSucceedResponse(payload));
}

export function* handleSucceedResponse(data) {
  yield put(createVisit.actions.send(data));
  const { succeedCreate } = yield race({
    succeedCreate: take(createVisit.consts.SUCCEED),
    rejectedCreate: take(createVisit.consts.REJECTED),
  });
  if (succeedCreate) {
    yield put({
      type: success.consts.UPDATE,
      payload: { id: 'virtualVisit.details.visitScheduled' },
    });
    browserHistory.replace(MESSAGES);
  }
}

export function* overlapVirtualVisit() {
  const payload = yield select(selectOverlapModalEntity);
  yield call(() => handleSucceedResponse(payload));
}

export default function* addVirtualVisitSaga() {
  yield takeLatest(createVisit.consts.INIT, addVisitWorker);
  yield takeLatest(createVisit.consts.OVERLAP, overlapVirtualVisit);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/add-virtual-visit-saga.js